/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* 

REDA - LISTEN TO VARIANT CHANGES TO UPDATE THE LABEL

*/

function setOptionLabel(variant) {
  const optionInput = document.querySelector("input[value='" + variant.option1 +"']");
  const optionWrapper = optionInput.closest(".ProductForm__Option");
  const optionLabel = optionWrapper.querySelector(".ProductForm__Label");
  const optionName = optionLabel.firstChild.textContent;
  const optionSpan = optionLabel.querySelector('span');
  const currentUnitIndex = optionSpan.dataset.unitIndex;
  const optionValue = variant.option1;
  const optionUnits = optionValue.split('/');
  
  const optionToShow = optionUnits.length === 2 ? optionUnits[currentUnitIndex]: optionValue;

  optionLabel.innerHTML = `${optionName}<span class="variant-label-option-value" data-option='${optionValue}' data-unit-index=${currentUnitIndex}>${optionToShow}</span>
`;
}
        

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log(variant);
  setOptionLabel(variant);
});


/* 

END OF REDA - LISTEN TO VARIANT CHANGES TO UPDATE THE LABEL

*/

function serialize (data) {
	let obj = {};
	for (let [key, value] of data) {
		if (obj[key] !== undefined) {
			if (!Array.isArray(obj[key])) {
				obj[key] = [obj[key]];
			}
			obj[key].push(value);
		} else {
			obj[key] = value;
		}
	}
	return obj;
}





function custAddToCart(event) {
    var _this4 = this;

    event.preventDefault(); // Prevent form to be submitted
    

    var addToCartButton = this; // First, we switch the status of the button

    addToCartButton.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

    var formElement = addToCartButton.parentElement;
    let a = new FormData(formElement)
    fetch("".concat(window.routes.cartAddUrl, ".js"), {
      body: JSON.stringify(serialize(a)),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      var quantityElement = formElement.querySelector('[name="quantity"]');

      if (response.ok) {
        addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

        _this4.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: _this4.currentVariant,
            quantity: quantityElement ? parseInt(quantityElement.value) : 1
          }
        }));
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          addToCartButton.removeAttribute('disabled');
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
    event.preventDefault();
  }
  $(document).ready(() => {
    const links = document.querySelectorAll('.my.ProductForm__AddToCart');
    links.forEach(link => {
        link.addEventListener('click', custAddToCart);
    });  
  })



// function openModal(title, type) {
//   let sizeHtml = '';
//   let typeHtml = '';
//   let url = 'https://cdn.shopify.com/s/files/1/0163/2986/7364/t/125/assets/';
  
//   let images = {
//     Sweater: { 
//       images: ['Dog-sweater-S1.png', 'Dog-sweater-M1.png','Dog-sweater-L1.png'],
//       size: '160px',
//       symbols: ['S', 'M', 'L'],
//       sizeTypes: ['Length', 'Chest', 'Neck'],
//       sizes: [
//         [{in: '10.5 inches', cm: '27 cm'}, {in: '11 - 13 inches', cm: '28 - 33 cm'}, {in: '7 to 10 inches', cm: '18 - 25 cm'}],
//         [{in: '12.5 inches', cm: '32 cm'}, {in: '13 - 15 inches', cm: '33 - 38 cm'}, {in: '9 to 12 inches', cm: '23 - 30 cm'}],
//         [{in: '14 inches', cm: '61 cm'}, {in: '15 - 17 inches', cm: '38 - 43 cm'}, {in: '11 to 13 inches', cm: '28 - 33 cm'}],
//       ],
//       measure: 'brussels griffon-sweater2.png' 
//     },
//     Collar: { 
//       images: ['Colar-dog-sizes-xs1.png', 'Colar-dog-sizes-s1.png','Colar-dog-sizes-M.png'],
//       size: '180px',
//       symbols: ['XS', 'S', 'M'],
//       sizeTypes: ['Length', 'Chest', 'Neck'],
//       sizes: [
//         [{in: '10.5 inches', cm: '27 cm'}, {in: '11 - 13 inches', cm: '28 - 33 cm'}, {in: '7 to 10 inches', cm: '18 - 25 cm'}],
//         [{in: '12.5 inches', cm: '32 cm'}, {in: '13 - 15 inches', cm: '33 - 38 cm'}, {in: '9 to 12 inches', cm: '23 - 30 cm'}],
//         [{in: '14 inches', cm: '61 cm'}, {in: '15 - 17 inches', cm: '38 - 43 cm'}, {in: '11 to 13 inches', cm: '28 - 33 cm'}],
//       ],
//       measure: 'brussels griffon-collar2.png' 
//     }
//   };
  

//   images[type].images.forEach((image, i) => {
//     sizeHtml += `
//       <div class="text-center modal-line-height">
//         <div class="img-container">
//           <img src="${url+image}" width="${ images[type].size }"/>
//         </div>
        
//         <strong>${images[type].symbols[i]}</strong>
//     `;

//     images[type].sizes[i].forEach((size, j) => {
//       sizeHtml += `
//         <div>${size.in} (${size.cm})</div>
//       `;
//     })

//     sizeHtml += '</div>';
//   });

//   images[type].sizeTypes.forEach((typ, i) => {
//     typeHtml += `<strong>${typ}</strong>`
//   })
  
  
//   let html = `
//     <div class="size-modal" id="sizeModal">
//      <div class="size-modal-body">
//          <div style="display: flex; justify-content: flex-end; margin-bottom: 20px;">
//             <button id="closeModal">x</button>
//          </div>
//         <h3 class="SectionHeader__Heading Heading u-h3 text-center modal-title">${title}</h3>

//         <div class="sizes">
            
//             <div class="info-box text-center">
//               <strong>Size</strong>
//               ${typeHtml}
//             </div>
            
//             ${sizeHtml}
//         </div>
//         <br /><br /><br />
//         <h3 class="SectionHeader__Heading Heading u-h3 text-center">How to measure</h3>
//         <center>
//           <img src="${url+images[type].measure}" width="300" />

//           <br /> <br />
//           <a href="mailto:davina@shayapets.com" class="Button Button--primary">CONTACT US</a>
//           <br /><br />
//         </center>
        
//      </div>
//   </div>
//   `
//   $('body').prepend(html);
//   $('body').css('overflowY', 'hidden');

//   document.getElementById("closeModal").addEventListener("click", () => {
//     document.getElementById("sizeModal").remove();
//     $('body').css('overflowY', 'scroll');
//   }); 
// }


document.addEventListener("DOMContentLoaded", function() {
  // Get the modal
  var modal = document.getElementById("sizeChartModal");

  // Get the button that opens the modal
  var btn = document.querySelector(".size-chart");

  // Get the <span> element that closes the modal
  var span = document.querySelector(".close");

  // When the user clicks the button, open the modal 
  btn.onclick = function() {
    modal.style.display = "block";
    document.body.style.overflow = "hidden"; // Prevent body from scrolling
    console.log("Size chart button clicked, modal opened.");
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
    document.body.style.overflow = "auto"; // Re-enable body scrolling
    console.log("Close button clicked, modal closed.");
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
      document.body.style.overflow = "auto"; // Re-enable body scrolling
      console.log("Clicked outside the modal, modal closed.");
    }
  }
});
